var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 0.0194702H0.428571C0.191518 0.0194702 0 0.210988 0 0.448042V7.0909C0 7.32795 0.191518 7.51947 0.428571 7.51947H5.51786V9.01947H3.21429C3.09643 9.01947 3 9.1159 3 9.23376V9.87661C3 9.93554 3.04821 9.98376 3.10714 9.98376H8.89286C8.95179 9.98376 9 9.93554 9 9.87661V9.23376C9 9.1159 8.90357 9.01947 8.78571 9.01947H6.48214V7.51947H11.5714C11.8085 7.51947 12 7.32795 12 7.0909V0.448042C12 0.210988 11.8085 0.0194702 11.5714 0.0194702ZM11.0357 6.55518H0.964286V0.983756H11.0357V6.55518Z",
    fill: "#46ADC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.e8a31d3513ca31dd43c0cdc3ed456269.svg";
export { ForwardRef as ReactComponent };